export default __webpack_public_path__ + "static/media/0001.1e600c60.jpg";